import type { ReactNode } from "react";
import { Button, Result } from "antd";
import { Link, useLocation } from "react-router-dom";

import { editionServesPath } from "./editionRoutes";

/** The page shown instead of a cloud page in the SASE edition. */
export function EditionNotAvailable() {
  return (
    <Result
      status="404"
      title="Not part of this console"
      subTitle="This console is the SASE edition. This page belongs to services that are not installed here."
      extra={
        <Link to="/sase">
          <Button type="primary">Go to SASE</Button>
        </Link>
      }
    />
  );
}

/** Renders `children` unless the SASE edition does not serve the current page. */
export default function EditionGate({
  edition,
  children,
}: {
  edition: boolean;
  children: ReactNode;
}) {
  const { pathname } = useLocation();
  if (edition && !editionServesPath(pathname)) return <EditionNotAvailable />;
  return <>{children}</>;
}
